import { render, staticRenderFns } from "./ProjectPage.vue?vue&type=template&id=a0bba52c&scoped=true"
import script from "./ProjectPage.vue?vue&type=script&lang=js"
export * from "./ProjectPage.vue?vue&type=script&lang=js"
import style0 from "./ProjectPage.vue?vue&type=style&index=0&id=a0bba52c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0bba52c",
  null
  
)

export default component.exports